import { type RouteObject } from 'react-router-dom';
import { RootLayout } from './RootLayout';
import { AppLayout } from './AppLayout';
import { NotFoundRedirect } from './NotFoundRedirect';
import { LandingScreen } from '@/src/screens/LandingScreen';
import { LoginScreen } from '@/src/screens/LoginScreen';
import { SignUpScreen } from '@/src/screens/SignUpScreen';
import { ForgotPasswordScreen } from '@/src/screens/ForgotPasswordScreen';
import { HomeScreen } from '@/src/screens/HomeScreen';
import { DashboardScreen } from '@/src/screens/DashboardScreen';
import { GardensScreen } from '@/src/screens/GardensScreen';
import { GardenDetailScreen } from '@/src/screens/GardenDetailScreen';
import { SharedGardenScreen } from '@/src/screens/SharedGardenScreen';
import { PlantsScreen } from '@/src/screens/PlantsScreen';
import { GardenConfigScreen } from '@/src/screens/GardenConfigScreen';
import { HarvestScreen } from '@/src/screens/HarvestScreen';
import { CalendarScreen } from '@/src/screens/CalendarScreen';
import { SettingsScreen } from '@/src/screens/SettingsScreen';
import { ChangePasswordScreen } from '@/src/screens/ChangePasswordScreen';
import { AdminScreen } from '@/src/screens/AdminScreen';

export const routes: RouteObject[] = [
  {
    element: <RootLayout />,
    children: [
      { path: '/', element: <LandingScreen /> },
      { path: '/login', element: <LoginScreen /> },
      { path: '/sign-up', element: <SignUpScreen /> },
      { path: '/forgot-password', element: <ForgotPasswordScreen /> },
      // Public share links — outside AppLayout auth gate
      { path: '/gardens/:gardenid/share', element: <SharedGardenScreen /> },
      { path: '/gardens/:gardenid/shared', element: <SharedGardenScreen /> },
      {
        element: <AppLayout />,
        children: [
          { path: '/app', element: <HomeScreen /> },
          { path: '/dashboard', element: <DashboardScreen /> },
          { path: '/calendar', element: <CalendarScreen /> },
          { path: '/gardens', element: <GardensScreen /> },
          { path: '/gardens/:gardenid', element: <GardenDetailScreen /> },
          { path: '/plants', element: <PlantsScreen /> },
          { path: '/garden-config', element: <GardenConfigScreen /> },
          { path: '/harvest', element: <HarvestScreen /> },
          { path: '/settings', element: <SettingsScreen /> },
          { path: '/change-password', element: <ChangePasswordScreen /> },
          { path: '/admin', element: <AdminScreen /> },
          { path: '*', element: <NotFoundRedirect /> },
        ],
      },
    ],
  },
];
